export const MSN_STORE_CLID = 'msn_store'
